module.exports = __webpack_public_path__ + "img/plus-icon.958ded40.svg";